export class AppMessage {

	message: string;

	data: any;

	flag: boolean;

}
